/**
 * There will be one saga file per component
 */
import { put } from 'redux-saga/effects';
import axios from 'src/api/Api';
import {
    GET_BANNER_DETAILS_SUCCESS,
    GET_BANNER_DETAILS_FAILURE,
    GET_BANNER_LENGTH,
    SET_BANNER_FREQUECY,
} from './../actions/constants';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { setDestructive } from '../actions';
import { checkImpersonationActive, checkProxyActive } from 'src/utils/util';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export function* getBannerDetails() {
    const url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/calendar/bannerinfo`;
    try {
        if(!localStorage.getItem('baseSiteId')){
            return;
        }
        const result = yield axios.get(url).then((response) => response.data);
        !checkProxyActive() &&
            !checkImpersonationActive() && (result?.bannerInfoWsDTO || []).filter(
            (item) => item.messageType === 'userDestructiveMessage'
        ).length > 0 ? yield put(setDestructive(true)) : yield put(setDestructive(false));
        yield put({
            type: GET_BANNER_DETAILS_SUCCESS,
            payload: result?.bannerInfoWsDTO,
        });
        yield put({
            type: GET_BANNER_LENGTH,
            payload: result?.bannerInfoWsDTO,
        });
        yield put({
            type: SET_BANNER_FREQUECY,
            payload: result?.refreshRate,
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
        });
        yield put({
            type: GET_BANNER_DETAILS_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
